export const CONNECT_API_REDUCER_PATH = 'connectApi';
